import { autoUpdate, computePosition, flip } from '@floating-ui/dom';
import { Autocomplete } from 'stimulus-autocomplete';
import accessibleAutocomplete from 'accessible-autocomplete';

// Enhances <select> elements with accessible-autocomplete, or delegates to
// stimulus-autocomplete for remote search fields (input + results targets).
export default class extends Autocomplete {
  static values = {
    required: Boolean,
    prompt: String,
    menuPosition: String
  };

  connect() {
    if (this.element.tagName === 'SELECT') {
      this.connectSelectAutocomplete();
      return;
    }

    if (!this.hasInputTarget || !this.hasResultsTarget) return;

    super.connect();
  }

  connectSelectAutocomplete() {
    const wrapperElements = this.element.parentNode.querySelectorAll(
      '.autocomplete__wrapper'
    );

    if (wrapperElements.length === 1) {
      wrapperElements[0].parentNode?.remove();
    }

    accessibleAutocomplete.enhanceSelectElement({
      defaultValue: '',
      selectElement: this.element,
      displayMenu: 'overlay',
      required: this.requiredValue,
      placeholder: this.promptValue,
      confirmOnBlur: true,
      showAllValues: true,
      dropdownArrow: () => ''
    });

    const trigger = this.element.parentElement.querySelector('.autocomplete__input');
    const content = this.element.parentElement.querySelector('.autocomplete__menu');

    const updatePosition = () => {
      computePosition(trigger, content, {
        middleware: [
          flip({
            fallbackPlacements: ['bottom', 'top']
          })
        ]
      }).then(({ x, y, placement }) => {
        Object.assign(content.style, {
          left: `${x}px`,
          top: `${y}px`
        });

        content.dataset.placement = placement;
      });
    };

    if (content.hasAttribute('data-placement')) return;

    updatePosition();
    autoUpdate(trigger, content, updatePosition);
  }
}
